import React from 'react';
import { Loading, EmptyState } from '@fourthwall/components';
import * as S from '../../../../styled/Centered/CenteredContent.styled';
export const CreatorMessagesEmptyState = ({ vm: { isLoading, subtitle, buttonLabel, to }, }) => (React.createElement(S.CenteredContent, null,
    React.createElement(Loading, { isLoading: isLoading },
        React.createElement(EmptyState, { title: "You haven\u2019t sent any messages yet", subtitle: subtitle, label: buttonLabel, to: to }))));
